import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import { SuppliersContext } from 'src/sections/manage_suppliers/SuppliersContext';
import { ManageSupplier } from 'src/types/manage-suppliers/ManageSupplier';
import { stopPropagation } from 'src/utils';
import { useContextSelector } from 'use-context-selector';

const ProgramInfoCell = (props: GridCellProps) => {
  const { t } = useTranslation();
  const dataItem = props.dataItem as ManageSupplier;
  const openProgramInfo = useContextSelector(
    SuppliersContext,
    (context) => context.openProgramInfo
  );
  const openingProgramInfoId = useContextSelector(
    SuppliersContext,
    (context) => context.openingProgramInfoId
  );
  const isLoadingProgramInfo = useContextSelector(
    SuppliersContext,
    (context) => context.isLoadingProgramInfo
  );

  const hasProgramInfo = Boolean(dataItem.programInfo);

  const handleClick = useCallback(
    (e: MouseEvent) => {
      stopPropagation(e);
      if (!dataItem.programInfo) {
        return;
      }
      openProgramInfo(dataItem.programInfo);
    },
    [dataItem.programInfo, openProgramInfo]
  );

  const isOpeningProgramInfo =
    hasProgramInfo && isLoadingProgramInfo && openingProgramInfoId === dataItem.programInfo;

  return (
    <td className={props.className} style={props.style}>
      {hasProgramInfo ? (
        <div className="flex h-full w-full items-stretch justify-center px-2">
          <Button
            type="button"
            color="info"
            onClick={handleClick}
            size="sm"
            className="w-fit text-[12px]"
            loading={isOpeningProgramInfo}
          >
            {t('Program Info')}
          </Button>
        </div>
      ) : null}
    </td>
  );
};

export default ProgramInfoCell;
